import React from "react";
import * as Styled from "./EmptySearchContainer.styles";
import { ASSETS } from "../../../../utils/config";

// gordon-0915-video-block-media-pane-pixabay-embed-first-record-tier: a
// provider FAILURE (bad/missing API key, rate limit, upstream outage) and a
// genuine zero-result search both used to render this exact same "No results
// found" copy — indistinguishable to the user, and indistinguishable in a
// screenshot. `isError` renders a distinct message + a Retry action instead.
function EmptySearchContainer({ isError = false, onRetry = null }) {
  return (
    <Styled.Container>
      <Styled.ContainerChild>
        <Styled.ImageContainer>
          <img
            src={ASSETS.segmentEditor.SearchIcon}
            alt="This is search icon"
            width={"34.63px"}
            height={"34.63px"}
          />
        </Styled.ImageContainer>
        <Styled.TextContainer>
          <Styled.TextParagraph>
            {isError ? (
              <>
                Could not load results. <br />
                Please try again.
              </>
            ) : (
              <>
                No results found for your search. <br />
                Please try different keywords.
              </>
            )}
          </Styled.TextParagraph>
          {isError && onRetry && (
            <Styled.RetryButton type="button" onClick={onRetry}>
              Retry
            </Styled.RetryButton>
          )}
        </Styled.TextContainer>
      </Styled.ContainerChild>
    </Styled.Container>
  );
}

export default EmptySearchContainer;
